import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {BooleanParameterComponent} from './boolean/boolean-parameter.component';
import {DefaultProviderComponent} from './default-provider/default-provider.component';
import {EnabledProvidersComponent} from './enabled-providers/enabled-providers.component';
import {GlobalPaymentSplitRulesComponent} from './global-payment-split-rules/global-payment-split-rules.component';
import {SettingsDialogComponent} from './settings-dialog/settings-dialog.component';
import {StringParameterComponent} from './string/string-parameter.component';
import {TrackingParameterComponent} from './tracking/tracking-parameter.component';
import {GateweeCollectionConfigParameterComponent} from './gatewee-collection-config/gatewee-collection-config-parameter.component';
import {FeeBatchMinimumParameterComponent} from './fee-batch-minimum/fee-batch-minimum-parameter.component';
import {ProvidersBaseFeesParameterComponent} from './providers-base-fees/providers-base-fees-parameter.component';
import {DefaultRecipientSettingsParameterComponent} from './default-recipient-settings/default-recipient-settings-parameter.component';
import {AntifraudParameterComponent} from './antifraud/antifraud-parameter.component';
import {ProviderSettingsOverridesParameterComponent} from './provider-settings-overrides/provider-settings-overrides-parameter.component';
import {ProviderCapabilitiesOverrideParameterComponent} from './provider-capabilities-override/provider-capabilities-override-parameter.component';
import {FeeCollectionPolicyParameterComponent} from './fee-collection-policy/fee-collection-policy-parameter.component';
import {BankingInfoParameterComponent} from './banking-info/banking-info-parameter.component';

/**
 * Exports standalone settings sub-components (used in dialogs).
 * GateweeSettingsComponent is declared in ComponentsV2Module so it has
 * access to GateweeContentPageComponent, GateweeTableV2Component, etc.
 */
@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    BooleanParameterComponent,
    StringParameterComponent,
    EnabledProvidersComponent,
    DefaultProviderComponent,
    SettingsDialogComponent,
    TrackingParameterComponent,
    GlobalPaymentSplitRulesComponent,
    GateweeCollectionConfigParameterComponent,
    FeeBatchMinimumParameterComponent,
    ProvidersBaseFeesParameterComponent,
    DefaultRecipientSettingsParameterComponent,
    AntifraudParameterComponent,
    ProviderSettingsOverridesParameterComponent,
    ProviderCapabilitiesOverrideParameterComponent,
    FeeCollectionPolicyParameterComponent,
    BankingInfoParameterComponent,
  ],
  exports: [
    BooleanParameterComponent,
    StringParameterComponent,
    EnabledProvidersComponent,
    DefaultProviderComponent,
    SettingsDialogComponent,
    TrackingParameterComponent,
    GlobalPaymentSplitRulesComponent,
    GateweeCollectionConfigParameterComponent,
    FeeBatchMinimumParameterComponent,
    ProvidersBaseFeesParameterComponent,
    DefaultRecipientSettingsParameterComponent,
    AntifraudParameterComponent,
    ProviderSettingsOverridesParameterComponent,
    ProviderCapabilitiesOverrideParameterComponent,
    FeeCollectionPolicyParameterComponent,
    BankingInfoParameterComponent,
  ],
})
export class GateweeSettingsModule {}
